import { Injectable } from '@angular/core';
import { VerticalTypeEnum } from '../../shared/vertical-type.enum';
import { ApiService } from '../../../shared/index';
import { NaaProfileType } from './naa-profile-type.model';
import { NaaProfileTypeManagementCompanyDto } from './dto/naa-profile-type-management-company.dto';
import { NaaProfileTypeOwnerDto } from './dto/naa-profile-type-owner.dto';
import { NaaProfileTypePropertyDto } from './dto/naa-profile-type-property.dto';
import { NaaPropertyTypeDto } from './dto/naa-property-type.dto';
import { NaaHousingCategoryTypeDto } from './dto/naa-housing-category-type.dto';

@Injectable({ providedIn: 'root' })
export class VerticalNaaService {
  public constructor(private _apiService: ApiService) {}

  public getNaaProfileTypes(): Promise<Array<NaaProfileType>> {
    return this._apiService.get('ProfileTypes').then((data: Array<NaaProfileType>) => {
      data = data.filter((x) => x.AssociationVerticalTypeId == VerticalTypeEnum.ApartmentAssociation);
      return data;
    });
  }

  // #region ManagementCompany
  getProfileTypeManagementCompanyForProfileId(profileId: number): Promise<NaaProfileTypeManagementCompanyDto> {
    return this._apiService.get(`ProfileTypes/VertAptAssoc_ProfileType_ManagementCompanies/GetByProfileId/${profileId}`);
  }

  createProfileTypeManagementCompany(profileTypeManagementCompanyDto: NaaProfileTypeManagementCompanyDto): Promise<number> {
    return this._apiService.post(`ProfileTypes/VertAptAssoc_ProfileType_ManagementCompanies`, profileTypeManagementCompanyDto);
  }

  updateProfileTypeManagementCompany(profileTypeManagementCompanyDto: NaaProfileTypeManagementCompanyDto): Promise<void> {
    return this._apiService.put(
      `ProfileTypes/VertAptAssoc_ProfileType_ManagementCompanies/${profileTypeManagementCompanyDto.Id}`,
      profileTypeManagementCompanyDto
    );
  }
  // #endregion

  // #region Owner
  getProfileTypeOwnerForProfileId(profileId: number): Promise<NaaProfileTypeOwnerDto> {
    return this._apiService.get(`ProfileTypes/VertAptAssoc_ProfileType_Owners/GetByProfileId/${profileId}`);
  }

  createProfileTypeOwner(profileTypeOwnerDto: NaaProfileTypeOwnerDto): Promise<number> {
    return this._apiService.post('ProfileTypes/VertAptAssoc_ProfileType_Owners', profileTypeOwnerDto);
  }

  updateProfileTypeOwner(profileTypeOwnerDto: NaaProfileTypeOwnerDto) {
    return this._apiService.put(`ProfileTypes/VertAptAssoc_ProfileType_Owners/${profileTypeOwnerDto.Id}`, profileTypeOwnerDto);
  }
  // #endregion

  // #region Property
  getPropertyTypes(): Promise<NaaPropertyTypeDto[]> {
    return this._apiService.get('ProfileTypes/VertAptAssoc_PropertyTypes');
  }

  getHousingCategoryTypes(): Promise<NaaHousingCategoryTypeDto[]> {
    return this._apiService.get('ProfileTypes/VertAptAssoc_HousingCategoryTypes');
  }

  getProfileTypePropertyForProfileId(profileId: number): Promise<NaaProfileTypePropertyDto> {
    return this._apiService.get(`ProfileTypes/VertAptAssoc_ProfileType_Properties/GetByProfileId/${profileId}`);
  }

  createProfileTypeProperty(profileTypePropertyDto: NaaProfileTypePropertyDto): Promise<number> {
    return this._apiService.post('ProfileTypes/VertAptAssoc_ProfileType_Properties', profileTypePropertyDto);
  }

  updateProfileTypeProperty(profileTypePropertyDto: NaaProfileTypePropertyDto): Promise<void> {
    return this._apiService.put(`ProfileTypes/VertAptAssoc_ProfileType_Properties/${profileTypePropertyDto.Id}`, profileTypePropertyDto);
  }
  // #endregion
}
